<template>
  <div>
    <div>
      <h1>My Networks</h1>
      <p class="card-text">
        Create a virtual network using the <strong>Add network</strong> button below then subscribe your nodes to the
        network using the <strong>Add node</strong> button.
      </p>
      <b-button variant="primary" @click="openModal">
        <font-awesome-icon icon="network-wired" />
        Add network
      </b-button>
    </div>
    <network v-for="network in networks" :network="network" :key="network.uid"></network>
  </div>
</template>

<script type="text/javascript">
import Network from './Network'

export default {
  name: 'NetworkList',
  props: {
    networks: Array
  },
  components: {
    Network
  },
  methods: {
    openModal() {
      this.$router.push({ name: 'newNetwork' })
    }
  }
}
</script>
